import {
  PUSH_NOTIFICATION_TO_QUEUE,
  REMOVE_NOTIFICATION_FROM_QUEUE
} from "../constants/ActionTypes";

import { getUniqueId } from "../utils/uniqueIdGenerator";

export const clearNotification = id => ({
  type: REMOVE_NOTIFICATION_FROM_QUEUE,
  id
});

export const showNotification = ({
  message,
  notificationType,
  dismissDelay=5000
}) => ({
  type: PUSH_NOTIFICATION_TO_QUEUE,
  notification: {
    id: getUniqueId(),
    message,
    type: notificationType,
    dismissDelay
  }
});
